export default {
	debug: false,
	tokenName: 'token.v1',
	socketUrl: 'https://cb.kjt.kz:4000',
	mainUrl: '/api/v1',
	docsUrl: 'https://docs.kjt.kz'
}
